import styled from 'styled-components';

const CalloutGroup = styled.div`
	flex-basis: 45%;
	margin-bottom: 2rem;
	max-width: 400px;
`;

export const Styled = {
	CalloutGroup,
};
